export const stringURlReplacement = (value: string) => {
  const urlReplace = value.replace(
    /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,100}(\/\S*)?)/g,
    '#@!$1#@!',
  );
  return urlReplace.split('#@!');
};
